module.exports = __webpack_public_path__ + "static/media/golem-min.532f1146.png";